import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getDepartmentsRequest } from '../services/surveys';

export interface DepartmentsEntity {
  id: string;
  memberCount: {
    groups: string;
    participants: string;
    director?: string;
    employee?: string;
    manager?: string;
  };
  name: string;
  type: string;
}

interface UseFulfillDepartmentsParams {
  closeModal?: () => void;
  active?: boolean;
}

export const useFulfillDepartments = ({ active = false }: UseFulfillDepartmentsParams = {}) => {
  const params = useParams();
  const surveyId = params.surveyId || '1';
  const [departments, setDepartments] = useState<DepartmentsEntity[]>([]);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (!active) return;

    (async () => {
      try {
        setLoading(true);
        const departments = await getDepartmentsRequest(surveyId);
        setDepartments(departments.items);
        setError('');
      } catch (err) {
        setError('Failed to fetch departments');
        setDepartments([]);
      } finally {
        setLoading(false);
      }
    })();
  }, [surveyId, active]);

  return { departments, isLoading, error };
};
